<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>キャンペーン</HeadingOne>

    <div v-for="(campaign, index) in campaignList" :key="index" class="post">
      <a :href="campaign.url" class="atag">
        <div class="row">
          <div class="col-12 col-md-4 photo">
            <img :src="campaign.image_url" class="img-fluid" />
          </div>
          <div class="col-12 col-md-8 info">
            <h2 class="title">{{ campaign.title }}</h2>
            <p class="text">{{ campaign.text }}</p>
          </div>
        </div>
      </a>
    </div>

    <BtngroupSingle v-if="readMoreFlag" class="-margin-lg">
      <BtnMain class="-normal" @click.prevent="showMore"> もっと見る </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { getCampaignList } from "@/utils/CmsHelper";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import HeadingOne from "@/components/heading/HeadingOne";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";

export default {
  name: "Cp001",
  components: { HeadingOne, BtnMain, BtngroupSingle, BreadcrumbGroup },
  setup() {
    setMeta({
      title: "キャンペーン",
      description:
        "au PAY スマートローンのキャンペーンの一覧ページになります。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,キャンペーン",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "キャンペーン",
          active: true,
        },
      ],
      isDisabled: false,
      readMoreFlag: false,
      campaignList: [],
    };
  },
  mounted() {
    this.getCampaignList("1");
  },
  methods: {
    getCampaignList(first_view_flag = "1") {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        getCampaignList(first_view_flag)
          .then((res) => {
            this.campaignList = this.campaignList.concat(res.campaign || []);
            this.readMoreFlag = res.read_more_flag;
          })
          .catch((error) => {
            goToErrorPage(error);
          })
          .finally(() => {
            this.isDisabled = false;
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    showMore() {
      this.getCampaignList("0");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.post {
  border-bottom: $secondary dotted 1px;
  padding-bottom: 20px;
  margin-bottom: 30px;
  &:nth-last-of-type(2) {
    border-bottom: none;
  }
  .info {
    > .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      @include mq-up(md) {
        font-size: 16px;
      }
    }
    > .text {
      margin-bottom: 0;
    }
  }
  > .atag {
    &:hover {
      text-decoration: underline;
      .photo {
        opacity: 0.75;
      }
    }
    &:visited {
      color: $visited;
    }
  }
}
</style>
